export default __webpack_public_path__ + "static/media/save.b15869bf.svg";